import { validation } from '@/util/validation.js';
export default {
  align: 'center',
  addBtn: false,
  editBtn: false,
  delBtn: false,
  column: [
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      search: true,
      width: 150,
      props: {
        label: 'title',
        value: 'key',
      },
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
      rules: [
        {
          required: true,
          message: '请选择车场名称',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '车牌号',
      prop: 'carNo',
      rules: [
        {
          required: false,
          pattern:validation.carPlate,
          message: '请输入车牌号',
          trigger: 'change',
        },

      ],
    },
    {
      label: '客户姓名',
      prop: 'customerName',

      rules: [
        {
          required: false,
          pattern:validation.name,
          message: '请输入客户姓名',
          trigger: 'change',
        },

      ],
    },
    {
      label: '客户手机',
      prop: 'customerPhone',
      rules: [
        {
          required: false,
          pattern:validation.phone,
          message: '请输入手机号',
          trigger: 'change',
        },

      ],
    },
    {
      label: '状态',
      prop: 'status',
      search: true,
      width: 70,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_month_status',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      span: 8,
      editDisplay: false,
      addDisplay: false,
      rules: [
        {
          // required: true,
          message: '请输入同步标识  0未同步  1已同步',
          trigger: 'change',
        },
      ],
    },
    {
      label: '租赁起期',
      prop: 'dateStartRange',
      searchRange: true,
      type: 'daterange',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd',
      rules: [
        {
          required: true,
          message: '请选择租赁起期',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '租赁止期',
      prop: 'dateEndRange',
      searchRange: true,
      type: 'daterange',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd',
    },
    {
      label: '支付时间',
      prop: 'payTimeRange',
      searchRange: true,
      type: 'daterange',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd',
    },
  ],
};
